import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row gx-4 gx-lg-5"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col px-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-4" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Beställ")
], -1)
const _hoisted_5 = { class: "col-md-6 mt-4 mt-md-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Uppgifter", -1)
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "full-name",
  class: "form-label"
}, "Namn", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "address",
  class: "form-label"
}, "Adress", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "zip-code",
  class: "form-label"
}, "Postnummer", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "form-label"
}, "Ort", -1)
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "Emailddress", -1)
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "swish-number",
  class: "form-label"
}, "Telefonnummer", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  id: "emailHelp",
  class: "form-text"
}, "Detta måste vara samma nummer som du Swishar ifrån.", -1)
const _hoisted_21 = { class: "mb-3 text-center" }
const _hoisted_22 = { class: "text-danger fw-bolder fw-bolder" }
const _hoisted_23 = { class: "text-danger fw-bolder fw-bolder" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/swish-QR-small.png",
  alt: "Swish QR-kod",
  style: {"max-height":"500px"}
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary d-block mx-auto btn-custom-size"
}, "JAG HAR SWISHAT", -1)
const _hoisted_26 = { class: "col-md-6" }

import { useRoute, useRouter } from 'vue-router';
    import { onMounted, ref, computed } from 'vue';
    import { OrderDTO } from '@/types/OrderDTO';
    import { ArticleViewModel } from '@/types/ArticleViewModel';
    import { CategoryViewModel } from '@/types/CategoryViewModel';
    import { orderApi } from '@/services/order.service';
    import { articleApi } from '@/services/article.service';
    import ArticleCard from '@/components/ArticleCard.vue';
    import Breadcrumbs from '@/components/Breadcrumbs.vue';
    import Spinner from '@/components/Spinner.vue';
    import { useMeta } from '@/composables/meta';
    import { useCanonical } from '@/composables/canonical';

    import { useRootStore } from '@/store/root.store';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Order',
  setup(__props) {

    const rootStore = useRootStore();

    const router = useRouter();
    const route = useRoute();

    const vm = ref<OrderDTO>({} as OrderDTO);
    const article = ref<ArticleViewModel>({} as ArticleViewModel);
    const isLoading = ref<boolean>(true);

    function createLinkToArticle() {
        return router.resolve({ name: `Article-${selectedCategory.value?.urlSlug}`, params: { id: article.value?.urlSlug } }).fullPath;
    }

    const breadcrumbs = computed(() => {
        return [
            {
                name: selectedCategory.value?.name,
                path: selectedCategory.value?.urlSlug,
                active: false
            },
            {
                name: article.value.modelName + ' ' + article.value.name,
                path: createLinkToArticle(),
                active: false
            },
            {
                name: 'Beställ',
                path: '',
                active: true
            }
        ]
    });

    const selectedCategory = computed(() => {
        return rootStore.categories.length
            ? rootStore.categories.find(x => x.id === article.value.categoryId)
            : {} as CategoryViewModel;
    });

    async function onSubmit() {
        if (window.confirm('Har du swishat?')) {
            try {
                const res = await orderApi.add({ ...vm.value, articleId: article.value.id });

                if (res)
                    return router.push({ name: 'OrderConfirm' });
                else
                    throw 'Något gick snett. Försök igen. Om inte det fungerar så kontakta oss';
            } catch (e) {
                alert('Något gick snett. Försök igen. Om inte det fungerar så kontakta oss');
            }
        }
    }

    onMounted(async () => {
        document.title = 'Laddar...';

        const urlSlug = route.params.slug.toString();
        try {
            const res = await articleApi.fetch(urlSlug);

            if (res.isSold) {
                alert('Tyvärr, artikeln är såld.');
                router.push('/');
            }

            article.value = res;

            useMeta(`Beställ ${res.modelName} ${res.name}`, `Här kan du beställa ${res.modelName} ${res.name}`);
            useCanonical(route.path.substring(1));

            isLoading.value = false;

        } catch (e) {
            alert('Du måste välja en artikel för att beställa.');
            router.push('/');
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(Breadcrumbs, { items: _unref(breadcrumbs) }, null, 8, ["items"])
            ])
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("form", {
              onSubmit: _withModifiers(onSubmit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "full-name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.value.fullName) = $event))
                }, null, 512), [
                  [_vModelText, vm.value.fullName]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "address",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.value.address) = $event))
                }, null, 512), [
                  [_vModelText, vm.value.address]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "zip-code",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vm.value.zipCode) = $event))
                }, null, 512), [
                  [_vModelText, vm.value.zipCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "city",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((vm.value.city) = $event))
                }, null, 512), [
                  [_vModelText, vm.value.city]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "email",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((vm.value.email) = $event))
                }, null, 512), [
                  [_vModelText, vm.value.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "swish-number",
                  "aria-describedby": "swish-number-help",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((vm.value.swishNumber) = $event))
                }, null, 512), [
                  [_vModelText, vm.value.swishNumber]
                ]),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h4", null, [
                  _createTextVNode("Använd QR-koden eller swisha "),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(article.value.price) + ":-", 1),
                  _createTextVNode(" till 070-755 47 76 (Mikael Nilsson) och "),
                  _createElementVNode("span", _hoisted_23, "skriv '" + _toDisplayString(article.value.id) + "' i beskrivning", 1),
                  _createTextVNode(". När du har swishat så gå ned på sidan och tryck på 'JAG HAR SWISHAT'")
                ]),
                _hoisted_24
              ]),
              _hoisted_25
            ], 40, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(ArticleCard, { article: article.value }, null, 8, ["article"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Spinner, { spinn: isLoading.value }, null, 8, ["spinn"])
  ], 64))
}
}

})